import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainLayout from './layout/main';
import HomePage from './pages/home';
import ServicePage from './pages/service';
import AboutPage from './pages/about';
import UnitPage from './pages/unit';
import ContactPage from './pages/contact';
import {  ThemeProvider } from '@mui/system';
import { createTheme } from '@mui/material/styles';
import AppTheme from './style/theme/main';

import PricingPage from './pages/pricing';


function App() {
  return (
    <ThemeProvider theme={createTheme(AppTheme)}>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path='service' element={<ServicePage />} />
            <Route path='about' element={<AboutPage />} />
            <Route path='pricing' element={<PricingPage />} />
          </Route>
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/unit' element={<UnitPage />} />
        </Routes>
      </BrowserRouter>

    </ThemeProvider>
  );
}

export default App;
